import { useMediaQuery } from "@mui/material";
import MobileFooter from "./Mobile";
import DesktopFooter from "./Desktop";
export default function Footer() {
  const isMobile = useMediaQuery("(max-width: 768px)");
  return <>{isMobile ? <MobileFooter /> : <DesktopFooter />}</>;
}
